<script lang="ts">
    import "dayjs/locale/id";
    dayjs.locale("id");

    import { page } from "$app/stores";
    import { dayjs } from "svelte-time";
    import { slide } from "svelte/transition";
    import { Splide, SplideSlide } from "@splidejs/svelte-splide";

    import "@splidejs/svelte-splide/css/core";
    import { afterUpdate } from "svelte";
    import FilterViewCategory from "./FilterViewCategory.svelte";
    import { children } from "svelte/internal";

    export let onSubmitSearching: any;
    export let onSetChangeSearch: any;
    export let keywordSearch: string;
    export let onDeleteSearching: any;
    export let categories: any = [];
    export let currentNamePage: string;
    export let isCategories: boolean = false;
    export let handleViewCategoryTrue: any;
    export let handleViewCategoryFalse: any;
    export let viewCategory: any;

    function generateCategoryURL(category: any) {
        return category?.slug;
        // return `/news/categories/${category?.slug}`;
    }

    let urlPath = "";

    afterUpdate(() => {
        const { pathname } = window.location;
        const pathSegments = pathname.split("/");
        if (pathSegments[1] === "news" && pathSegments[2] === "categories") {
            urlPath = pathSegments[3];
        } else {
            urlPath = "";
        }
    });

    function clickOutside(element: any, callbackFunction: any) {
        function onClick(event: any) {
            if (!element.contains(event.target)) {
                callbackFunction();
            }
        }

        document.body.addEventListener("click", onClick);

        return {
            update(newCallbackFunction: any) {
                callbackFunction = newCallbackFunction;
            },
            destroy() {
                document.body.removeEventListener("click", onClick);
            },
        };
    }

    $: categoriesv2 = categories?.find(
        (item: any) => item.slug === $page.params.slug,
    );

    afterUpdate(() => {
        categoriesv2 = categories?.find(
            (item: any) => item.slug === $page.params.slug,
        );
    });
</script>

<div
    class="rounded-[1rem] xl:w-[100%] lg:w-[100%] md:w-[100%] w-full md:mb-0 mb-4 h-max z-2 top-[120px] self-start flex flex-col xl:flex-row content-center bg-white"
>
    <form
        on:submit={onSubmitSearching}
        class="relative w-full xl:w-[40%] justify-center flex"
    >
        <div
            class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
        >
            <svg
                class="w-4 h-4 text-gray-500"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
            >
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
            </svg>
        </div>
        <input
            type="search"
            on:change={onSetChangeSearch}
            bind:value={keywordSearch}
            class="max-w-full placeh w-full py-[12px] pl-12 pr-5 text-md !bg-transparent text-gray-900 placeholder:!text-gray-600 border-none rounded-[0.7rem]"
            placeholder={`Cari ${currentNamePage === "" ? "Berita" : currentNamePage}`}
        />
        {#if keywordSearch !== ""}
            <button
                type="button"
                on:click|preventDefault={() => {
                    keywordSearch = "";
                    onDeleteSearching();
                }}
                class="outline-none active:outline-none border-0 absolute inset-y-0 end-0 flex items-center pe-2"
            >
                <svg
                    class="w-5 h-5 text-gray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    ><path
                        fill="currentColor"
                        d="m12 10.587l4.95-4.95l1.414 1.414l-4.95 4.95l4.95 4.95l-1.415 1.414l-4.95-4.95l-4.949 4.95l-1.414-1.415l4.95-4.95l-4.95-4.95L7.05 5.638z"
                    /></svg
                >
            </button>
        {/if}
    </form>

    {#if categories && categoriesv2?.children?.data?.length > 0}
        <div
            class="overflow-auto flex flex-wrap w-full mt-3 mb-3 lg:mt-0 items-center justify-center xl:justify-end"
            style="scrollbar-width: thin; scrollbar-color: rgba(155, 155, 155, 0.5) transparent;"
        >
            <a
                href={`/news/categories/${categoriesv2?.parent?.data?.slug ? categoriesv2?.parent?.data?.slug : categoriesv2?.slug}`}
                data-sveltekit-reload="off"
                class={`mr-4
                    ${
                        (categoriesv2?.parent?.data?.slug
                            ? categoriesv2?.parent?.data?.slug
                            : categoriesv2?.slug) === $page.params.slug
                            ? "!font-bold"
                            : ""
                    }  
                    ${
                        isCategories
                            ? "no-underline hover:no-underline text-[17px] text-slate-700 font-normal block mb-0 hover:bg-slate-100 px-2 py-1 rounded-md"
                            : "no-underline hover:no-underline text-[17px] text-slate-700 flex items-center gap-1 capitalize mb-0 hover:bg-slate-100 px-2 py-1 font-bold rounded-md"
                    }`}
            >
                <span>Semua</span>
            </a>
            {#each categoriesv2?.children?.data?.slice(0, 3) as category}
                {#if urlPath === generateCategoryURL(category)}
                    <a
                        data-sveltekit-reload="off"
                        href={`/news/categories/${category?.slug}`}
                        class={`no-underline hover:no-underline text-[17px] text-slate-700 font-normal item-category ${
                            urlPath === generateCategoryURL(category)
                                ? "flex items-center gap-1"
                                : ""
                        } capitalize mr-4 w-max font-semibold rounded-[10px]`}
                    >
                        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" aria-label="Tag Category" ><g><path d="M5.653 14.48a1.386 1.386 0 0 0 .985-.408l7.161-7.161a2.309 2.309 0 0 0 .68-1.642V1.391A1.4 1.4 0 0 0 13.085 0H9.21a2.307 2.307 0 0 0-1.642.68L.407 7.841a1.4 1.4 0 0 0 0 1.971l4.261 4.261a1.383 1.383 0 0 0 .985.407ZM13.085.929a.465.465 0 0 1 .465.465v3.875a1.384 1.384 0 0 1-.408.985l-7.161 7.162a.465.465 0 0 1-.657 0l-4.26-4.262a.466.466 0 0 1 0-.657l7.161-7.16A1.386 1.386 0 0 1 9.21.929Z"></path><path d="M10.763 5.11a1.394 1.394 0 1 0-1.394-1.393 1.395 1.395 0 0 0 1.394 1.393Zm0-1.858a.465.465 0 1 1-.465.465.465.465 0 0 1 .465-.465Z"></path></g></svg> -->
                        <span>{category?.name}</span>
                    </a>
                {/if}
                {#if urlPath !== generateCategoryURL(category)}
                    <a
                        data-sveltekit-reload="off"
                        href={`/news/categories/${category?.slug}/`}
                        class="no-underline hover:no-underline mr-5 text-slate-600 font-normal w-auto hover:bg-slate-100 px-2 py-1 rounded-md"
                    >
                        <span>{category?.name}</span>
                    </a>
                {/if}
            {/each}
            {#if categoriesv2?.children?.data?.length > 3}
                <button
                    use:clickOutside={() => {
                        handleViewCategoryFalse();
                    }}
                    on:click={(event) => {
                        event.stopPropagation();
                        handleViewCategoryTrue();
                    }}
                    class="flex flex-row items-center hover:bg-slate-100 px-2 py-1 rounded-lg"
                >
                    Lainnya
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g id="ri:arrow-drop-down-fill">
                            <path
                                id="Vector"
                                d="M12 14L8 10H16L12 14Z"
                                fill="#080808"
                                fill-opacity="0.4"
                            />
                        </g>
                    </svg>
                </button>
            {/if}
        </div>
    {/if}
</div>
{#if viewCategory}
    <FilterViewCategory
        categoriesV2Filtered={categoriesv2}
        {generateCategoryURL}
        {urlPath}
    />
{/if}

<style lang="css">
    :global(.tooltip.custom-tooltip) {
        --tooltip-box-shadow: 0 !important;
        --tooltip-color: white !important;
        font-family: Helvetica, Arial, sans-serif;
    }
    .news-wrapper {
        border: 1px solid #e4e7eb;
    }
    .news__content-category::-webkit-scrollbar {
        display: none;
    }
    .news__content-category {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .splide__arrows {
        display: none !important;
    }
    .splide__pagination {
        display: none !important;
    }
</style>
